import { NavLink, useNavigate } from "react-router-dom";
import { useAdmin } from "../../context/AdminContext";

const allNavItems = [
  { label: "Dashboard",  icon: "📊", path: "/admin/dashboard",  adminOnly: false },
  { label: "Products",   icon: "👗", path: "/admin/products",   adminOnly: false },
  { label: "Orders",     icon: "📦", path: "/admin/orders",     adminOnly: false },
  { label: "Customers",  icon: "👥", path: "/admin/customers",  adminOnly: true  },
  { label: "Inventory",  icon: "🏪", path: "/admin/inventory",  adminOnly: false },
  { label: "Discounts",  icon: "🎟️", path: "/admin/discounts",  adminOnly: false },
  { label: "Shipping",   icon: "🚚", path: "/admin/shipping",   adminOnly: false },
  { label: "Staff",      icon: "🔐", path: "/admin/staff",      adminOnly: true  },
  { label: "SEO",        icon: "🔍", path: "/admin/seo",        adminOnly: true  },
];

export default function Sidebar() {
  const { admin, logout } = useAdmin();
  const navigate = useNavigate();
  const isAdmin  = admin?.role === "admin";

  const navItems = allNavItems.filter(item => !item.adminOnly || isAdmin);

  function handleLogout() {
    logout();
    navigate("/admin/login");
  }

  return (
    <aside className="fixed top-0 left-0 h-screen w-64 bg-gray-900 border-r border-gray-800 flex flex-col z-10">
      {/* Brand */}
      <div className="px-6 py-6 border-b border-gray-800">
  <div className="flex flex-col items-start">
    <span
      className="text-white font-bold tracking-[0.15em] uppercase text-sm leading-tight"
      style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
    >
      Sagar Lifestyle NY
    </span>
    <div className="w-full flex items-center gap-1.5 my-1">
      <div className="flex-1 h-px bg-amber-600" />
      <span className="text-amber-600 text-[8px] font-bold tracking-[0.3em] uppercase">LLC</span>
      <div className="flex-1 h-px bg-amber-600" />
    </div>
  </div>
  <p className="text-xs text-gray-500 mt-0.5">Admin Panel</p>
</div>

      {/* Nav */}
      <nav className="flex-1 px-3 py-4 space-y-1">
        {navItems.map(item => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition
              ${isActive
                ? "bg-rose-600 text-white"
                : "text-gray-400 hover:bg-gray-800 hover:text-white"
              }`
            }
          >
            <span>{item.icon}</span>
            {item.label}
          </NavLink>
        ))}
      </nav>

      {/* Role Badge */}
      <div className="px-4 py-2">
        <div className={`text-center text-xs font-semibold py-1.5 rounded-lg ${isAdmin ? "bg-rose-900/40 text-rose-400" : "bg-gray-800 text-gray-400"}`}>
          {isAdmin ? "👑 Administrator" : "🛠️ Store Manager"}
        </div>
      </div>

      {/* User + Logout */}
      <div className="px-4 py-4 border-t border-gray-800">
        <div className="flex items-center gap-3 px-2 mb-3">
          <div className="w-8 h-8 rounded-full bg-rose-600 flex items-center justify-center text-white text-sm font-bold">
            {admin?.name?.charAt(0).toUpperCase()}
          </div>
          <div>
            <p className="text-sm text-white font-medium">{admin?.name}</p>
            <p className="text-xs text-gray-500 capitalize">{admin?.role?.replace("_", " ")}</p>
          </div>
        </div>
        <button
          onClick={handleLogout}
          className="w-full text-left px-4 py-2 text-sm text-gray-400 hover:text-rose-400 hover:bg-gray-800 rounded-lg transition">
          Sign Out
        </button>
      </div>
    </aside>
  );
}